import { createContext } from 'react'

const KnowledgeContext = createContext({})

export default KnowledgeContext
